var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultilingualSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 65,
    viewBox: "0 0 73 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5686 49.5556H63.6809M39.5686 49.5556L33.1387 63M39.5686 49.5556L49.1991 29.4192C49.9751 27.7966 50.3631 26.9853 50.894 26.729C51.3557 26.506 51.8939 26.506 52.3556 26.729C52.8865 26.9853 53.2745 27.7966 54.0505 29.4192L63.6809 49.5556M63.6809 49.5556L70.1109 63M2.88867 9.22222H23.0553M23.0553 9.22222H34.8192M23.0553 9.22222V2.5M34.8192 9.22222H43.222M34.8192 9.22222C33.1517 19.162 29.2821 28.1661 23.6118 35.7227M29.7776 39.4722C27.7188 38.5473 25.6187 37.2609 23.6118 35.7227M23.6118 35.7227C19.0658 32.2383 14.998 27.4618 12.972 22.6667M23.6118 35.7227C18.2182 42.9104 11.1954 48.7886 2.88867 52.9167",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultilingualSupport);
export default __webpack_public_path__ + "static/media/MultilingualSupport.20fd8c378212b472e85c47d3dcabb7e9.svg";
export { ForwardRef as ReactComponent };